import { getCognitoRole } from 'api/utils/auth';

export const useIsAdmin = () => {
  const isAdmin = getCognitoRole() === 'ADMIN';
  return isAdmin;
};
